import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Layout & Common
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";

// Page components
import Header from "layouts/profile/components/Header";
import AccountDetails from "layouts/profile/components/AccountDetails";
import TimeOffForm from "./TimeOffForm";
import { CardHeader } from "@mui/material";

function Overview() {
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [imageModalOpen, setImageModalOpen] = useState(false);


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <MDBox mt={4}>
      <Grid
          container
          justifyContent="center"
          alignItems="flex-start" 
        >

        
      <Grid item size={{ xs: 12, sm: 10, md: 6 }} >
          <MDBox p={3} sx={{ border: "1px solid #e0e0e0", borderRadius: "12px", width: "100%" }}>
              <CardHeader
                    subheader="Send Day off or Vacation"
                    title="Request Time Off"
                />
            <TimeOffForm />
          </MDBox>
        </Grid>
        </Grid>
        </MDBox>

      <Footer />

    </DashboardLayout>
  );
}

export default Overview;
